import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'

const DISPUTS_ENDPOINTS: Partial<Record<Roles, string>> = {
  [Roles.Trader]: '/v1/disputs',
  [Roles.Merchant]: '/v1/merchant/disputs',
} as const

// Функция для получения актуального endpoint
const getEndpoint = (): string => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  return userRole ? DISPUTS_ENDPOINTS[userRole]! : DISPUTS_ENDPOINTS[Roles.Trader]!
}

export const disputsAPI = {
  get endpoint() {
    return getEndpoint()
  },
  get list() {
    return getEndpoint()
  },
  item: (id: string) => {
    const endpoint = getEndpoint()
    return `${endpoint}/${id}`
  },
  get create() {
    const endpoint = getEndpoint()
    return `${endpoint}/create`
  },
  get updateStatus() {
    const endpoint = getEndpoint()
    return `${endpoint}/status`
  },
  getDisput: (id: string) => {
    const endpoint = getEndpoint()
    return `${endpoint}/${id}`
  },
}
